import React from 'react';
import { ErrorPage } from '../ErrorPage';

export const NotFound = () => {
    return <ErrorPage error="not-found" />;
};

export default NotFound;
